import { Close } from '@mui/icons-material'
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'

import { AttachmentList } from '@common/components'
import { openInNewTab, useSmallScreen } from '@common/utils'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {boolean} props.open
 * @param {Function} props.onClose
 * @param {Object[]} props.attachments
 */
export default function AttachmentsModal({ open, onClose, attachments }) {
  const isSmallScreen = useSmallScreen()

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <DialogTitle>Feedback Attachments ({attachments?.length ?? 0})</DialogTitle>
        <IconButton onClick={onClose} sx={{ mr: 1.5 }}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        {attachments && (
          <AttachmentList
            type="remote"
            orientation={isSmallScreen.mobile ? 'vertical' : 'horizontal'}
            attachments={attachments}
            onClick={(file) => openInNewTab(file.url)}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
